const listaDeTiposSolicitacao = (state) => {
    if (!state.items || !Array.isArray(state.items)) {
        return [];
    }
    return state.items;
}

const loadingTiposSolicitacao = (state) => {
    return state.carregando
}

export {
    listaDeTiposSolicitacao,
    loadingTiposSolicitacao
}
